module.exports = __webpack_public_path__ + "static/media/title_dlc_01.f44f61dc.png";